import { useTranslation } from 'react-i18next';
import useGetNtxProfile from '../../../../hooks/NTX/useGetNtxProfile';
import QrCode from './QrCode';
import { useState } from 'react';

const ProfileSidebar = () => {
  const { i18n, t } = useTranslation();
  const { UserProfile: Profile } = useGetNtxProfile();
  const [showQrCode, setShowQrCode] = useState(false);
  return (
    <>
      <div className="desktop-sticky-top">
        <div className="profile-img">
          {Profile?.personImage === null ? (
            <img src="../../../assets/img/user/manEmp.png" alt="" loading="lazy" />
          ) : (
            <img src={Profile?.personImage?.filePath} alt="" loading="lazy" />
          )}
        </div>

        <h6>{i18n.language === 'ar' ? Profile?.name2 : Profile?.name}</h6>
        <div className="mb-3 text-inverse text-opacity-50 fw-bold mt-n2">
          {Profile?.emailAddress || '@Neatix'}
        </div>
        {/* زر لإخفاء أو إظهار QrCode */}
        <button
          onClick={() => setShowQrCode(!showQrCode)}
          className="btn btn-outline-theme mb-2 w-100">
          {showQrCode ? `${t('Hide')} QR Code` : `${t('Show')} QR Code`}
        </button>

        {/* عرض QrCode بناءً على الحالة */}
        {showQrCode && <QrCode />}
      </div>
    </>
  );
};

export default ProfileSidebar;
